import AjaxResolver from 'owd/module/ajax';

export default class CategoriesResolver extends AjaxResolver {
	shouldPushState() {
		return true;
	}

	pageIn() {
		const deferred = $.Deferred();

		$('.logo').each(function() {
			var html = $(this).html();
			$(this).html(html);
		});

		const $content = $('[data-products-content], [data-products-content-placeholder]');

		if ($content.length) {
			$content.css({
				display: ''
			}).removeAttr('hidden').transition({
				opacity: 1
			}, 500, 'ease-out');
		}

		setTimeout(() => {
			deferred.resolve();
		}, 500);

		$('[data-products="products"]').addClass('open');
		$('[data-products="categories"]').addClass('open');
		$('[data-products-options-toggle]').addClass('open');

		return deferred.promise();
	}

	pageOut() {
		const deferred = $.Deferred();

		const $content = $('[data-products-content]');

		if ($content.length) {
			$content.transition({
				opacity: 0
			}, 250, 'ease-out', () => {
				this.app.dom.$window.scrollTop(0);
			});
		}

		setTimeout(() => {
			deferred.resolve();
		}, 500);

		$('[data-products="products"]').removeClass('open');

		return deferred.promise();
	}

	updateContent($loadedContent) {
		const deferred = $.Deferred();

		const $oldContent = $('[data-products-content]');
		const $oldProducts = $('[data-products="products"]');
		const bodyClass = $loadedContent.find('.overall').data('body-class');
		const bodyTheme = $loadedContent.find('.overall').data('theme');

		$loadedContent.find('[data-products-content]').css({
			opacity: 0
		});
		$loadedContent.find('[data-products="products"]').removeClass('open');

		if (this.preventUpdateBodyClass !== true) {
			$('body').attr('class', bodyClass);
			$('body').attr('data-theme', bodyTheme);
		}

		$('.section-product').removeClass('section-product').removeClass('products-list').addClass('section-products');

		const $newContent = $loadedContent.find('[data-products-content]');
		const $newProducts = $loadedContent.find('[data-products="products"]');

		$oldContent.last().after($newContent);
		$oldProducts.last().after($newProducts);
		$oldContent.remove();
		$oldProducts.remove();

		deferred.resolve([$oldContent, $oldProducts], [$newContent, $newProducts]);

		return deferred.promise();
	}
}
